import { faqConstants } from "../constants";
import { faqService } from "../services";
import { alertActions } from ".";

export const faqActions = {
  index,
  show,
  update,
  _delete,
  store,
  addSection,
  deleteSection,
  updateSection,
  addFaqSectionDetails,
  deleteSectionDetail,
  updateSectionDetail,
};

function index(params) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      faqService.index(params).then(
        (data) => {
          dispatch(success(data));
          resolve(data);
        },
        (error) => {
          dispatch(alertActions.error(error.toString()));
          reject();
        }
      );
    });
  };

  function success(data) {
    return { type: faqConstants.GET_FAQ_SECTIONS_SUCCESS, payload: data };
  }
}

function show(id) {
  return faqService.show(id);
}

function update(request, id) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      faqService.update(request, id).then(
        (data) => {
          dispatch(success(data));
          dispatch(alertActions.success(data.message));
          resolve(data);
        },
        (error) => {
          dispatch(alertActions.error(error.toString()));
          reject();
        }
      );
    });
  };

  function success(data) {
    return { type: faqConstants.UPDATE_FAQ_SUCCESS, payload: data.data };
  }
}

function _delete(id) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      faqService._delete(id).then(
        (data) => {
          dispatch(success(data));
          dispatch(alertActions.success(data.message));
          resolve(data);
        },
        (error) => {
          dispatch(alertActions.error(error.toString()));
          reject();
        }
      );
    });
  };

  function success(data) {
    return { type: faqConstants.REMOVE_FAQ_SUCCESS, payload: data };
  }
}

function store(request) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      faqService.store(request).then(
        (data) => {
          dispatch(success(data));
          dispatch(alertActions.success(data.message));
          resolve(data);
        },
        (error) => {
          dispatch(alertActions.error(error.toString()));
          reject();
        }
      );
    });
  };

  function success(data) {
    return {
      type: faqConstants.STORE_FAQ_SUCCESS,
      payload: data.item,
    };
  }
}

function addSection(params) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      faqService.addSection(params).then(
        (data) => {
          dispatch(success(data));
          dispatch(alertActions.success(data.message));
          resolve(data);
        },
        (error) => {
          dispatch(alertActions.error(error.toString()));
          reject();
        }
      );
    });
  };

  function success(data) {
    return {
      type: faqConstants.ADD_FAQ_SECTION_SUCCCESS,
      payload: data.item,
    };
  }
}

function deleteSection(id) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      faqService.deleteSection(id).then(
        (data) => {
          dispatch(success(data));
          dispatch(alertActions.success(data.message));
          resolve(data);
        },
        (error) => {
          dispatch(alertActions.error(error.toString()));
          reject();
        }
      );
    });
  };

  function success(data) {
    return { type: faqConstants.REMOVE_FAQ_SUCCESS, payload: data };
  }
}

function updateSection(request) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      faqService.updateSection(request).then(
        (data) => {
          dispatch(success(data));
          dispatch(alertActions.success(data.message));
          resolve(data);
        },
        (error) => {
          dispatch(alertActions.error(error.toString()));
          reject();
        }
      );
    });
  };

  function success(data) {
    return {
      type: faqConstants.UPDATE_FAQ_SECTION_SUCCESS,
      payload: data.data,
    };
  }
}

function addFaqSectionDetails(params) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      faqService.addFaqSectionDetails(params).then(
        (data) => {
          dispatch(success(data));
          dispatch(alertActions.success(data.message));
          resolve(data);
        },
        (error) => {
          dispatch(alertActions.error(error.toString()));
          reject();
        }
      );
    });
  };

  function success(data) {
    return {
      type: faqConstants.ADD_FAQ_SECTION__DETAILS_SUCCCESS,
      payload: data.item,
    };
  }
}

function deleteSectionDetail(id) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      faqService.deleteSectionDetail(id).then(
        (data) => {
          dispatch(success(data));
          dispatch(alertActions.success(data.message));
          resolve(data);
        },
        (error) => {
          dispatch(alertActions.error(error.toString()));
          reject();
        }
      );
    });
  };

  function success(data) {
    return { type: faqConstants.REMOVE_FAQ_DETAIL_SUCCESS, payload: data };
  }
}

function updateSectionDetail(request) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      faqService.updateSectionDetail(request).then(
        (data) => {
          dispatch(success(data));
          dispatch(alertActions.success(data.message));
          resolve(data);
        },
        (error) => {
          dispatch(alertActions.error(error.toString()));
          reject();
        }
      );
    });
  };

  function success(data) {
    return {
      type: faqConstants.UPDATE_FAQ_SECTION_DETAIL_SUCCESS,
      payload: data.data,
    };
  }
}
